"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductCounts = void 0;
const react_1 = require("react");
const types_1 = require("@groupby/enrich-sdk/resource/_jsonapi/types");
const feature_flags_1 = require("../../feature-flags");
const hooks_1 = require("../../hooks");
const localization_1 = require("../../localization");
const hooks_2 = require("./");
const selectors_1 = require("../../store/selectors");
const useProductCounts = () => {
    const client = (0, hooks_1.useEnrichClient)();
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const isProductCountsEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.ProductCounts);
    const { addError } = (0, hooks_1.useNotification)();
    const classesRefresh = (0, selectors_1.useClassesRefreshSelector)();
    const selectedOrganizations = (0, selectors_1.useSelectedOrganizationsSelector)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const isOrganizationSelected = (0, selectors_1.useSelectedOrganizationsIdsSelector)().length > 0;
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [classTotals, setClassTotals] = (0, react_1.useState)({});
    const [categoryTotals, setCategoryTotals] = (0, react_1.useState)({});
    const [attributeTotals, setAttributeTotals] = (0, react_1.useState)({});
    const [productTotal, setProductTotal] = (0, react_1.useState)(0);
    const { activeFilter: filter } = (0, hooks_2.useFilter)({});
    const getMetaProducts = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const payload = { response: {} };
        try {
            setIsLoading(true);
            const allTotal = yield client.products.getTotal(filter);
            if (allTotal) {
                yield client.products.getPage({
                    filter,
                    fields: {
                        meta: [types_1.CollectionMetaParam.ATTRIBUTES, types_1.CollectionMetaParam.RELATIONSHIPS],
                    },
                }, payload);
                const countedClasses = (_a = payload.response.meta) === null || _a === void 0 ? void 0 : _a.relationships.class.values.reduce((acc, item) => (Object.assign(acc, { [item.actual]: item.total })), {});
                const countedCategories = (_b = payload.response.meta) === null || _b === void 0 ? void 0 : _b.relationships.categories.values.reduce((acc, item) => (Object.assign(acc, { [item.actual]: item.total })), {});
                // Perhaps there is a way to get attribute counts from the meta.relationships instead?
                const countedAttributes = payload.response.data
                    .reduce((acc, { attributes: { attributes } }) => acc.concat(attributes), [])
                    .reduce((acc, attr) => { var _a; return (Object.assign(acc, { [attr.id]: ((_a = acc[attr.id]) !== null && _a !== void 0 ? _a : 0) + 1 })); }, {});
                setClassTotals(countedClasses);
                setCategoryTotals(countedCategories);
                setAttributeTotals(countedAttributes);
                setProductTotal(payload.response.meta.total);
            }
        }
        catch (_c) {
            addError(t({ key: 'META_PRODUCTS_LOADING_ERROR' }));
        }
        finally {
            setIsLoading(false);
        }
    });
    (0, react_1.useEffect)(() => {
        if (isProductCountsEnabled && isOrganizationSelected && !isLoading) {
            void getMetaProducts();
        }
    }, [selectedOrganizations, classesRefresh, isProductCountsEnabled]);
    return {
        classTotals,
        categoryTotals,
        attributeTotals,
        productTotal,
        isLoading,
    };
};
exports.useProductCounts = useProductCounts;
exports.default = exports.useProductCounts;
